
import { InfoCommand } from "slotworks/commands/error/info-command";
import Contract from "slotworks/utils/contract";

export function NonFatalErrorCommand(messageId: string, sceneNames: string[] = ["error"], button?: any[], data?: any): Contract<void> {
    return InfoCommand(messageId, sceneNames, button, data);
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/commands/error/non-fatal-error-command.ts